<template>
  <v-card
    class="product-carrousel-card pa-2 pa-sm-4 pb-6 mx-auto"
    flat
    :to="to"
  >
    <img v-if="img" :src="`${img}?resize=1&w=600`" />
    <div
      v-if="title"
      class="
        d-flex
        justify-center
        align-center
        text-body-2 text-sm-h6 text-center
        font-weight-bold
        title
        mt-3
        px-5
      "
    >
      {{ title }}
    </div>
  </v-card>
</template>

<script>
export default {
  props: {
    img: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    to: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss">
.product-carrousel-card {
  aspect-ratio: 262/344;
  height: 330px;
  border-radius: 4px;
  .title {
    transition: all 0.2s;
    display: -webkit-box !important;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
  img {
    width: 100%;
    height: 100%;
    aspect-ratio: 1/1;
    height: 200px;
    object-fit: contain;
  }

  &::before {
    border-radius: inherit !important;
  }

  &:hover {
    box-shadow: 0px 25px 51px rgba(70, 59, 101, 0.05),
      0px 10.2747px 11.3915px rgba(70, 59, 101, 0.0298054),
      0px 3.05905px 3.39155px rgba(70, 59, 101, 0.0201946) !important;
  }
  &:hover .title {
    color: var(--v-primary-lighten2);
  }
}
</style>
